// extracted by mini-css-extract-plugin
export default {"searchWrapper":"Search_searchWrapper__79qjt","searchHeader":"Search_searchHeader__as+00"};